const routes = [
  {
    path: '/customization',
    name: 'site-customization',
    meta: {
      authRequired: true,
      roles: []
    },
    component: () => import('./Form.vue')
  }
]

export { routes }
export default routes
